"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFormat = void 0;
/**
 * 日期格式(特殊值：LL - 完整日期, relative - 相对日期)
 */
var DateFormat;
(function (DateFormat) {
    DateFormat["LL"] = "LL";
    DateFormat["YYYY_MM_DD"] = "YYYY/MM/DD";
    DateFormat["DD_MM_YYYY"] = "DD/MM/YYYY";
    DateFormat["MM_DD_YYYY"] = "MM/DD/YYYY";
    DateFormat["RELATIVE"] = "relative";
})(DateFormat = exports.DateFormat || (exports.DateFormat = {}));
